import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.CheckEligibility.title',
        defaultMessage: `Good news, you're eligible*`
    },
    suggestedAmountTitle: {
        id: '_.CheckEligibility.suggestedAmountTitle',
        defaultMessage: `You're eligible for up to {suggestedAmount}*`
    },
    benefitBorrow: {
        id: '_.CheckEligibility.benefitBorrow',
        defaultMessage: 'Borrow from 1 day to 60 months'
    },
    benefit24hourDecision: {
        id: '_.CheckEligibility.benefit24hourDecision',
        defaultMessage: 'Decision within 24 hours'
    },
    benefitRepayEarly: {
        id: '_.CheckEligibility.benefitRepayEarly',
        defaultMessage: 'Repay early for free at any time'
    },
    benefitInterestOnly: {
        id: '_.CheckEligibility.benefitInterestOnly',
        defaultMessage: '3-month interest-only repayment option'
    },
    terms: {
        id: '_.CheckEligibility.terms',
        defaultMessage:
            '*Final terms are subject to the strength of your application'
    },
    labelCta: {
        id: '_.CheckEligibility.labelCta',
        defaultMessage: "Applying won't affect your credit score"
    },
    cta: {
        id: '_.CheckEligibility.cta',
        defaultMessage: 'Next, add personal details'
    }
});
